// useCommentsByOrgId.ts
import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const useCommentsByOrgId = (orgId: string | null, contextFilters?: string[] | null) => {
  return useQuery({
    queryKey: ['orgComments', orgId, contextFilters?.join(',') ?? ''],
    queryFn: async () => {
      if (!orgId) return { orgComments: [], taskComments: {}, count: 0 }

      const query = contextFilters?.length ? `?context=${contextFilters.join(',')}` : ''

      const { data } = await axios.get(`${baseUrl}/aws/comments/org-comments/${orgId}${query}`)
      return data
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  })
}
